import { GroupFragment, UserFragment } from "@/generated/graphql";

type GroupMembers = Pick<GroupFragment, "groupMembers">;

/** Active (non-withdrawn) members of a group as plain users. */
export function getActiveMembers(group: GroupMembers): UserFragment[] {
  return group.groupMembers.flatMap((member) =>
    member.isActive && member.user != null ? [member.user] : []
  );
}

/** Withdrawn members of a group as plain users. */
export function getWithdrawnMembers(group: GroupMembers): UserFragment[] {
  return group.groupMembers.flatMap((member) =>
    !member.isActive && member.user != null ? [member.user] : []
  );
}
